import apiHandler from "./apiHandler";

const apiSSO = {
  getUrls: (name) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/sso/${name}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  check: (name, state) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/sso/${name}?state=${state}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiSSO;
